

// apply Maroon + Gold

import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../css/Sidebar.css";

function Sidebar() {
  const [openMaster, setOpenMaster] = useState(false);

  //const userRole = sessionStorage.getItem("role")?.replace(/"/g, '').trim();
  const userRole = sessionStorage.getItem("role");

  return (
    <div
      className="sidebar text-white p-3"
      style={{
        backgroundColor: "#800000",
        width: "250px",
        height: "100vh",
        top: 0,
        left: 0,
        overflowY: "auto",
      }}
    >

      <ul className="nav flex-column mt-4">
        
        <img 
          src="/images/aim.png"  
          alt="Logo"
          style={{ width: "200px", height: "150px", display: "block", margin: "0 auto" }}
        />

        {(userRole === "Admin" ||
          userRole === "HR" ||
          userRole === "Payroll") && (
          <li className="nav-item mb-2">
          <Link to="/welcome" className="nav-link sidebar-link">
            🏠 Home
          </Link>
        </li>
        )}

        {userRole === "Admin" && (
          <li className="nav-item mb-2">
            <Link to="/employee/addrole" className="nav-link sidebar-link">
              🏠 Add Role
            </Link>
          </li>
        )}


        {(userRole === "Admin" ||
          userRole === "HR" ||
          userRole === "Payroll") && (
          <li className="nav-item">
            <button
              className="nav-link sidebar-link w-100 text-start"
              onClick={() => setOpenMaster(!openMaster)}
            >
              📂 Master {openMaster ? "▲" : "▼"}
            </button>

            {openMaster && (
              <ul className="nav flex-column ms-3">
                <li className="nav-item">
                  <Link
                    to="/employee/allowances"
                    className="nav-link sidebar-link"
                  >
                    💰 Allowances
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/employee/deductions"
                    className="nav-link sidebar-link"
                  >
                    💰 Deductions
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/employee/department"
                    className="nav-link sidebar-link"
                  >
                    🏢 Department
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/employee/section"
                    className="nav-link sidebar-link"
                  >
                    📌 Section
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/employee/ptheader"
                    className="nav-link sidebar-link"
                  >
                    📑 PT Header
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/employee/list" className="nav-link sidebar-link">
                    👨‍💼 Add Employee
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/employee/leaves/balance-leaves"
                    className="nav-link sidebar-link"
                  >
                    📋 Leave Details
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/employee/leaves"
                    className="nav-link sidebar-link"
                  >
                    🌴 Add Leaves
                  </Link>
                </li>
              </ul>
            )}
          </li>
        )}


        {/* Payroll/HR menus */}
        {(userRole === "Admin" || userRole === "Payroll" || userRole === "HR") && (
          <>
            <li className="nav-item">
              <Link
                to="/employee/attendance/add-excel"
                className="nav-link sidebar-link"
              >
                📊 Add Attendance
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/employee/salary/process"
                className="nav-link sidebar-link"
              >
                💵 Salary Process
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/employee/salary-reports"
                className="nav-link sidebar-link"
              >
                📑 Salary Reports
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/employee/bulkinsert"
                className="nav-link sidebar-link"
              >
                📥 Add Employee Excel
              </Link>
            </li>
            
          </>
        )}

       {(userRole === "Admin" || userRole === "HR") && (
          <>
          <li className="nav-item">
              <Link
                to="/employee/leaveapplicationlist"
                className="nav-link sidebar-link"
              >
                📥 Leave Applications
              </Link>
            </li>
          </>
      )}

        {/* Employee role menus */}
        
        {userRole === "Employee" && (
          <>
            {/* <li className="nav-item mb-2">
              <Link
                to="/employee/my-attendance"
                className="nav-link sidebar-link"
              >
                📅 My Attendance
              </Link>
            </li> */}
            <li className="nav-item mb-2">
              <Link to="/employee/profile" className="nav-link sidebar-link">
                🏠 Profile
              </Link>
            </li>
            <li className="nav-item mb-2">
              <Link to="/employee/my-payslip" className="nav-link sidebar-link">
                💵 My Payslip
              </Link>
            </li>
            <li className="nav-item mb-2">
              <Link to="/employee/my-leaves" className="nav-link sidebar-link">
                🌴 Leave Details
              </Link>
            </li>
            <li className="nav-item mb-2">
              <Link to="/employee/apply-leave" className="nav-link sidebar-link">
                🌴 Apply Leave 
              </Link>
            </li>
            <li className="nav-item mb-2">
              <Link to="/employee/upload-documents" className="nav-link sidebar-link">
                📥 Upload Documents 
              </Link>
            </li>
            <li className="nav-item mb-2">
              <Link to="/employee/from16" className="nav-link sidebar-link">
                📥 From 16 
              </Link>
            </li>
          </>
        )}
        
      </ul>
    </div>
  );
}

export default Sidebar;




